interface Props {
  text: string
}
export const Time: React.FC<Props> = ({ text }) => {
  return (
    <div className="inline-block py-0 px-[8px] text-[10px] align-middle select-none">
      {text}
    </div>
  )
}
